
import { Field } from "@smartsoftware/reflex-core";
import { DexResourceModel } from "../abstracts/dexResource.model";

export enum SubscriptionType {
	Order = "Order"
}

export class IdentitySubscription extends DexResourceModel
{

    @Field(String)
    public internal_uuid: string = "";

    @Field(String)
    public objectType: SubscriptionType = SubscriptionType.Order;

    @Field(String)
    public emailAddress: string = "";

    constructor(data?: any) {
        super();
        this.mapData(data);
    }

    public get data(): any {
        let json = super.data;

        return json;
    }
}
